// extracted by mini-css-extract-plugin
export default {"wrapper":"PortalLogo-module__wrapper--MLvsF","resizable":"PortalLogo-module__resizable--ZCqrn","mobile":"PortalLogo-module__mobile--v4S_1"};